import axios from 'axios'

const endpoint = '/api/logs'

export default {
  get: payload => axios.post(endpoint, { page: payload.page, paginate: payload.paginate }, { headers: { 'X-Page-Size': payload.perPage } }),
}
